export const COLORS = {
    white: '#FFFFFF',
    black: '#181818',
    gray: '#D9D7E0',
    lightGray: '#F1F0F2',
    darkGray: '#9089A5',
    // Primary
    lightOrange: '#FFBEA4',
    orange: '#EF8D63',
    darkOrange: '#70371F',
    // Secondaries
    red: '#DE7272',
    green: '#91D89C',
    yellow: '#EFBF63',
    pink: '#EF6395',
    purple: '#7663EF',
    blue: '#558DE0',
};
// Videos where the video segmentation did not go as planned
export const JRE_BLACKLIST = [
    ...[
        1520,
        1521,
        1529,
        1547,
        1549,
        1498,
        1562,
        1563,
        1567,
    ],
    // MAYBE BLACKLIST (TO VERIFY)
    ...[
        1555,
        1497,
        1487,
        1481,
        1466,
        1463,
        1459,
        1446,
        1440,
        1433,
        1421,
        1420,
        1405,
        1400,
    ]
];
const LEX_BLACKLIST = [
    125,
    124,
    123,
    119,
    116,
    113,
    111,
    109,
    107,
    106,
    105,
    91,
    89,
    84,
];
export const LEX_WHITELIST = [
    140,
    139,
    138,
    136,
    135,
    134,
    132,
    130,
    129,
    128,
    127,
    121,
    117,
    114,
    112,
    110,
    101,
    98,
    94,
    88,
    81,
    80,
    73,
    71,
    49,
];
